module.exports = __webpack_public_path__ + "static/homepageBG3-10a17e2fff80c9fc38a372ed1c4e72f9.jpg";